// The room photo for visualizers/sunroom.js: the MANIFEST only, so an entry
// point can withdraw the visualizer from the rotation when there is no
// picture to light (orchestrator.js's disableVisualization, the same
// arrangement as warehouse-assets.js). The textures are loaded by the
// visualizer itself when it is on screen.
const MANIFEST_URL = 'textures/sunroom.json';

let _promise = null;
let _manifest = null;

// Resolves to the manifest, or to null when the photo is missing - said in
// the console, once. The depth map is optional here (it only occludes the
// dust); the photo and the measured planes are not.
export function preloadSunroomScene() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('sunroom.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      const photo = (m.variants || []).some(function (v) { return !v.role; });
      if (!photo) throw new Error('sunroom.json has no photo variant');
      if (!m.window || !m.room || !m.vanish) throw new Error('sunroom.json has no measured room (run tools/build-scenes.mjs)');
      _manifest = m;
      return m;
    })
    .catch(function (err) {
      console.error('[party-mode] sunroom scene unavailable, Sunroom will not be offered', err);
      _manifest = null;
      return null;
    });
  return _promise;
}

export function getSunroomScene() {
  return _manifest;
}
